export default __webpack_public_path__ + "static/img1-4d32ec97bdcdeb117e88a8edc96ea43c.png";